module.exports = __webpack_public_path__ + "static/2-3026a46ffc086f62274b5e4ab729c64c.jpg";